<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  opacity: 0.8;
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
::-webkit-scrollbar-thumb {
  background: #9dadbb;
  /*border: thin solid #fa9000;*/
  border-radius: 8px;
  -webkit-transition: background 0.25s linear;
}
::-webkit-scrollbar-track {
  // background: #F0F0F0;
  // border: 1px solid #F0F0F0;
  box-shadow: none;
  border-radius: 0;
}
.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* flex-wrap: wrap; */
}
.flex-space-between-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.flex-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.flex-flex-start-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.flex-space-around {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.flex-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.text1-hidden {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/App.vue